<SidebarShell
  :logo="short_logo"
  :brand_title="brand_name"
  :brand_subtitle="brand_subtitle"
  :initials="initials"
  :full_name="full_name"
  :is_admin="is_admin"
  @brand-click="select_global_portfolio"
>
  <!-- ✅ FORWARD SIDEBAR HEADER ACTIONS (X BUTTON) -->
  <template #sidebar-header-actions>
    <slot name="sidebar-header-actions"></slot>
  </template>

  <!-- CONTEXT -->
  <template #context>
    <SidebarContext
      :main_label="selected_portfolio"
      :sub_label="portfolio_context_subtitle"
      :items="drilldownItems"
      :active_id="local_active_property || active_drilldown_item"
      :open="dropdownOpen"
      @toggle="toggleDropdown"
      @select="select_drilldown_item"
    >
      <template #top>
        <div
          class="sidebar-context-top border-bottom border-secondary pb-2 mb-2"
          @click="select_global_portfolio"
        >
          <p class="text-dark fw-semibold text-xs mb-2">Drill-down</p>
          <p class="text-secondary fw-semibold text-xxs mb-0">
            SBPM Platinum Mine
          </p>
        </div>
      </template>
    </SidebarContext>
  </template>

  <!-- MENU -->
  <template #menu>
    <div class="sidebar-menu sidebar-menu-list px-2 mt-3">
      <div
        v-for="item in menuItems"
        :key="item.key"
        class="sidebar-menu-item d-flex align-items-start py-2 px-2 cursor-pointer text-uppercase position-relative fw-bold gap-2 rounded-2"
        :class="[
          active_menu_item === item.key
            ? 'bg-warning text-dark'
            : 'text-secondary'
        ]"
        :aria-label="item.label"
        :title="item.label"
        data-bs-toggle="tooltip"
        data-bs-placement="right"
        data-bs-offset="0,12"
        @click="select_menu_item(item.key)"
      >
        <i
          :class="[
            item.icon,
            'sidebar-menu-icon',
            'me-2',
            active_menu_item === item.key ? 'text-dark' : 'text-secondary'
          ]"
          :aria-label="item.label"
        ></i>

        <p class="sidebar-menu-label sidebar-menu-text text-dark fw-semibold text-xs mb-0">
          {{ item.label }}
        </p>
      </div>
    </div>
  </template>
</SidebarShell>
